import { ref, computed, onMounted } from 'vue';
import moment from 'moment';
import 'moment/locale/fr';
import http from '@/http.js';
import eventBus from '@/eventBus.js';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useRapportFunctions(props) {
    const parametres = ref([]);
    const anomalies = ref([]);
    const requetes = ref([]);
    const showModalRequetesInExecution = ref(false);
    const showModalJustif = ref(false);
    const perPage = ref(20);
    const currentPage = ref(1);
    const loaded = ref(true);
    const idExecution = ref("");
    const nomJeu = ref("");
    const nbRequetesFromJeu = ref("");
    const nom = ref("");
    const prenom = ref("");
    const email = ref("");
    const bdd = ref("");
    const schema = ref("");
    const nbRequetesAno = ref("");
    const nblignesAno = ref("");
    const nbJustif = ref("");
    const nbValid = ref("");
    const nbRefuse = ref("");
    const showNotification = ref(false);
    const notificationMessage = ref("");
    const notificationType = ref("info");

    const handleNotification = ({ toastMessage, toastType }) => {
        notificationMessage.value = toastMessage;
        notificationType.value = toastType;
        showNotification.value = true;
        setTimeout(() => {
            showNotification.value = false;
        }, 5000);
    };

    const getRapport = async () => {
        const data = await http.getRapport(props.executionData.idExecution);
        idExecution.value = data.idExecution;
        nomJeu.value = data.nomJeu;
        nbRequetesFromJeu.value = data.nbRequetesFromJeu;
        schema.value = data.schema;
        nom.value = data.nom;
        prenom.value = data.prenom;
        email.value = data.email;
        bdd.value = data.bdd;
        nbRequetesAno.value = data.nbRequetesAno;
        nblignesAno.value = data.nblignesAno;
        nbJustif.value = data.nbJustif;
        nbValid.value = data.nbValid;
        nbRefuse.value = data.nbRefuse;
        parametres.value = data.parametres;
    };

    const getRequetesFromExecution = async () => {
        const data = await http.getRequetesFromExecution(props.executionData.idExecution);
        requetes.value = data;
    };

    const getAnomalies = async () => {
        const data = await http.getAnomalies(props.executionData.idExecution);
        anomalies.value = data;
    };

    const handleShowModalJustif = () => {
        loaded.value = false;
        getAnomalies().finally(() => {
            loaded.value = true;
        });
        showModalJustif.value = !showModalJustif.value;
        showModalRequetesInExecution.value = false;
    };

    const handleShowModalRequeteInExecution = () => {
        loaded.value = false;
        getRequetesFromExecution().finally(() => {
            loaded.value = true;
        });
        showModalRequetesInExecution.value = !showModalRequetesInExecution.value;
        showModalJustif.value = false;
    };

    const momentDate = (date) => moment(date).format('DD/MM/YYYY - HH:mm:ss');

    const getFichier = async (idExecution) => {
        const data = await http.getFichier(idExecution);
        const blob = new Blob(['\ufeff', data], { type: 'text/csv;charset=utf-8' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `rapport_${idExecution}.csv`;
        link.click();
        URL.revokeObjectURL(link.href);
    };

    const find = computed(() => {
        const page = currentPage.value > 1 ? (currentPage.value - 1) * perPage.value : 0;
        return requetes.value.slice(page, page + perPage.value);
    });

    const rows = computed(() => requetes.value.length);

    onMounted(() => {
        getRapport();
        eventBus.on('reloadRapport', getRapport);
        eventBus.on('reloadRequete', getRequetesFromExecution);
        eventBus.on('reloadJustif', getAnomalies);
    });

    return {
        idExecution,
        nomJeu,
        nbRequetesFromJeu,
        nom,
        prenom,
        email,
        schema,
        bdd,
        nbRequetesAno,
        nblignesAno,
        nbJustif,
        nbValid,
        nbRefuse,
        parametres,
        anomalies,
        requetes,
        showModalRequetesInExecution,
        showModalJustif,
        loaded,
        perPage,
        currentPage,
        find,
        rows,
        momentDate,
        getFichier,
        handleShowModalJustif,
        handleShowModalRequeteInExecution,
        showNotification,
        notificationMessage,
        notificationType,
        handleNotification,
    };
}